type ProjectAssignmentError = {
    code?: unknown;
    message?: unknown;
    response?: {
        status?: unknown;
        code?: unknown;
        message?: unknown;
        data?: { code?: unknown; message?: unknown };
    };
};

/**
 * Only readiness/contract-lag failures are safe to retry. Authentication,
 * authorization and request-validation errors must be returned immediately.
 */
export const isTransientProjectAssignmentError = (error: unknown): boolean => {
    const record = error as ProjectAssignmentError | null;
    const values = [
        record?.code,
        record?.message,
        record?.response?.status,
        record?.response?.code,
        record?.response?.message,
        record?.response?.data?.code,
        record?.response?.data?.message,
    ]
        .filter(Boolean)
        .map((value) => String(value).toLowerCase());

    return values.some((value) =>
        value === '503'
        || value.includes('resource_contract_incomplete')
        || value.includes('connection_integration_not_ready'),
    );
};
